import { useState } from 'react';
import Page from './layout/Page';
import Card from "./layout/Card";
import React from 'react';
import {useLocation} from 'react-router-dom';
import {sendCallInstructions} from '../api';
import { showError } from '../utils';
import useAlert from '../hooks/useAlert';

export default function ChiamataInviaIstruzioni() {
    const location = useLocation();
    const { id, numero, chiamante_title } = location.state || {};
    const [istruzioni, setIstruzioni] = useState('');
    const alert = useAlert();

    const handleSendCallInstructionsClick = async () => {
        try {
            await sendCallInstructions(id, istruzioni);
            setIstruzioni(''); // Reset the instructions after sending
            alert({message: 'Istruzioni inviate con successo!'});
            window.history.back();

        } catch (e) {
            showError([e.message]);
        }
    };

    const istruzioniTextarea = (
        <div className="gas-form">
            <form className="form">
                <div className="form-fields">
                    <div className="input-form">
                        <textarea
                            rows="5"
                            placeholder="Inserisci le istruzioni da inviare alla segretaria"
                            value={istruzioni}
                            onChange={(e) => setIstruzioni(e.target.value)}
                        />
                    </div>    
                </div>
            </form>
        </div>
    );


    return (
        <Page title="Invia Istruzioni">
            <Card title={chiamante_title} content={numero} variant="call-base-info" />
            <Card title="Istruzioni" content={istruzioniTextarea} />
            <div style={{margin: '1rem'}}>
                <button className="submit" onClick={() => handleSendCallInstructionsClick()}>Invia istruzioni alla Segretaria</button>
            </div>
        </Page>
    );
}
